import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { UserEmailCheckResponse } from 'services/requests';
import { ApiError } from 'services/api.errors';
import { useQueryParams } from 'hooks/routes';
import { MutationKeys } from 'constants/mutationKeys';
import { Parameters } from 'constants/queryParameters';

export const useCheckIraUserEmail = () => {
  const employerId = useQueryParams(Parameters.employerId);

  const mutate = async (email: string) => {
    const { data } = await api.checkIraUserEmail(employerId, email);
    return data;
  };

  const mutationKey = MutationKeys.checkIraUserEmail;

  return useMutation<UserEmailCheckResponse, AxiosError<ApiError>, string>(
    mutationKey,
    mutate,
  );
};
